import React, { useEffect, useState } from "react";
import { PawPrint, Plus, Minus, Play } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import NeedSupport from "../components/NeedSupport";
import Reveal from "../components/Reveal";
import VideoModal from "../components/home/VideoModal";

const faqs = [
  "Lorem ipsum dolor sit amet odio netus leo?",
  "Accumsan feugiat parturient nibh metus dui lorem aliquam?",
  "Mattis gravida netus sociosqu turpis ex vulputate justo?",
  "Enim rhoncus fusce semper ac nostra?",
  "Dis urna nascetur dictumst ligula condimentum?",
  "Mus dictum pellentesque maximus molestie est?",
  "Lorem ipsum dolor sit amet odio netus leo?",
  "Accumsan feugiat parturient nibh metus dui lorem aliquam?",
  "Mattis gravida netus sociosqu turpis ex vulputate justo?",
  "Enim rhoncus fusce semper ac nostra?",
  "Dis urna nascetur dictumst ligula condimentum?",
  "Mus dictum pellentesque maximus molestie est?",
];

const ANSWER =
  "Lorem ipsum dolor sit amet in a neque augue aliquam. Tempus leo nec vestibulum erat nunc mollis nullam ad ex rhoncus ac. Eros tellus vulputate inceptos commodo morbi sed habitant egestas at laoreet ultricies.";

const FAQ = () => {
  const [open, setOpen] = useState(0);
  const [video, setVideo] = useState(false);

  useEffect(() => {
    document.title = "FAQ – Moggies & Doggies Veterinary Care";
  }, []);

  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner
          title="FAQ"
          subtitle="Discover Helpful Answers from Our Veterinary Experts"
          crumbs={["FAQ"]}
        />

        <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
          <div className="grid gap-12 lg:grid-cols-[1fr_0.9fr]">
            <div>
              <Reveal animation="rubberBand">
                <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
                  <PawPrint className="h-5 w-5" /> Common Questions
                </span>
              </Reveal>
              <Reveal animation="fadeInUp" delay={100}>
                <h2 className="mt-4 max-w-xl font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
                  Everything You Should Know About Our Process
                </h2>
              </Reveal>

              <div className="mt-8 space-y-4">
                {faqs.map((q, i) => (
                  <Reveal key={i} animation="fadeInUp" delay={i * 40}>
                    <div className={`overflow-hidden rounded-2xl border transition-colors ${open === i ? "border-pawelle-primary bg-white" : "border-pawelle-ink/10 bg-pawelle-bg"}`}>
                      <button
                        onClick={() => setOpen(open === i ? -1 : i)}
                        className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                      >
                        <span className="font-display text-[17px] font-semibold text-pawelle-ink">{q}</span>
                        <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full ${open === i ? "bg-pawelle-primary text-white" : "bg-white text-pawelle-primary"}`}>
                          {open === i ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                        </span>
                      </button>
                      <div className={`grid transition-all duration-300 ${open === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                        <div className="overflow-hidden">
                          <p className="px-6 pb-5 font-body text-[15px] leading-relaxed text-pawelle-body">{ANSWER}</p>
                        </div>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>

            {/* Video card */}
            <Reveal animation="fadeInRight" className="lg:sticky lg:top-28 lg:self-start">
              <div className="relative overflow-hidden rounded-[28px]">
                <img src="/pawelle/img_6.jpg" alt="Veterinary care" className="h-[460px] w-full object-cover" />
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-pawelle-ink/40">
                  <button
                    onClick={() => setVideo(true)}
                    className="pw-ripple relative flex h-16 w-16 items-center justify-center rounded-full bg-pawelle-primary text-white"
                    aria-label="Play intro"
                  >
                    <Play className="relative z-10 h-6 w-6 translate-x-0.5 fill-white" />
                  </button>
                  <span className="font-display text-[18px] font-semibold uppercase tracking-wide text-white">Play Intro</span>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        <NeedSupport />
      </main>
      <Footer />
      <VideoModal open={video} onClose={() => setVideo(false)} />
    </div>
  );
};

export default FAQ;
